import Vue from 'vue'
import Vuex from 'vuex'
import { getActivityEditors, occupyFeedEditor, releaseFeedEditor } from '../api/activityApi'
import { getTargetGroup } from '../api/targetGroupApi'
import { getSubscribedPlan, getSpaceUsersStatistics } from '../api/spaceApi'
import { getStoreOrdersAll } from '../api/productApi'
import { getWorkflowUsersStatistics, getWorkflow } from '../api/workflowApi'


Vue.use(Vuex)

export default new Vuex.Store({

    state: {
        list: [],
        feedEditingId: '',
        targetGroup: {},
        peopleStatistics: {},
        lock: false,
        lockPaymentFailed: false,
        lockNotAcceptedTerms: false,
        productPlan: {},
        peopleWorkflowStatistics: {},
        workflow: {},
        workflowBroken: false,
        storeOrdersStatistics: [],
    },
    mutations: {
        SET_TARGETGROUP(state, targetGroup) {
            state.targetGroup = targetGroup
        },
        SET_WORKFLOW(state, workflow) {
            state.workflow = workflow
        },
        SET_PEOPLESTATISTICS(state, peopleStatistics) {
            state.peopleStatistics = peopleStatistics
        },
        SET_ORDERSTATISTICS(state, storeOrdersStatistics) {
            state.storeOrdersStatistics = storeOrdersStatistics
        },
        SET_PEOPLEWORKFLOWSTATISTICS(state, peopleWorkflowStatistics) {
            state.peopleWorkflowStatistics = peopleWorkflowStatistics
        },
        SET_EDITORS(state, list) {
            state.list = list
        },
        SET_OCCUPY(state, feedEditingId) {
            state.feedEditingId = feedEditingId
        },
        RELEASE_EDITOR(state, feedEditingId) {
            state.feedEditingId = feedEditingId
        },
        SET_LOCK(state, val) {
            state.lock = val
        },
        SET_LOCK_PAYMENT_FAILED(state, val) {
            state.lockPaymentFailed = val
        },
        SET_LOCK_NOT_ACCEPTED_TERMS(state, val) {
            state.lockNotAcceptedTerms = val
        },
        SET_PRODUCTPLAN(state, plan) {
            state.productPlan = plan
        },
        SET_WORKFLOW_BROKEN(state, val) {
            state.workflowBroken = val
        },
        RESET_STATE(state) {
            Object.assign(state, {
                list: [],
                feedEditingId: '',
                targetGroup: {},
                peopleStatistics: {},
                lock: false,
                lockPaymentFailed: false,
                lockNotAcceptedTerms: false,
                productPlan: {},
                peopleWorkflowStatistics: {},
                workflow: {},
                workflowBroken: false,
                storeOrdersStatistics: [],
            })
        }
    },
    actions: {
        resetState({ commit }) {
            commit('RESET_STATE')
        },
        /*eslint-disable*/
        async getTargetGroup({ commit }, id) {
            try {
                const response = await getTargetGroup(id)

                if (response.status == 200) {
                    this.targetGroup = response.data.data
                }
                commit('SET_TARGETGROUP', this.targetGroup)
            } catch (error) {
                throw error;
            }
        },
        async getWorkflow({ commit }, id) {
            try {
                const response = await getWorkflow(id)

                if (response.status == 200) {
                    this.workflow = response.data.data
                }
                commit('SET_WORKFLOW', this.workflow)
            } catch (error) {
                throw error;
            }
        },
        async getSpaceUsersStatistics({ commit }, id) {
            try {
                const response = await getSpaceUsersStatistics(id);
                if (response.status == 200) {
                    this.peopleStatistics = response.data.meta
                }
                commit('SET_PEOPLESTATISTICS', this.peopleStatistics)
            } catch (error) {
                throw error;
            }
        },
        async getStoreOrdersAll({ commit }, id) {
            try {

                const response = await getStoreOrdersAll(id);
                if (response.status == 200) {
                    this.storeOrdersStatistics = response.data.data
                }
                commit('SET_ORDERSTATISTICS', this.storeOrdersStatistics)
            } catch (error) {
                throw error;
            }
        },
        async getWorkflowUsersStatistics({ commit }, id) {
            try {
                const response = await getWorkflowUsersStatistics(id);
                if (response.status == 200) {
                    this.peopleWorkflowStatistics = response.data.meta
                }
                commit('SET_PEOPLEWORKFLOWSTATISTICS', this.peopleWorkflowStatistics)
            } catch (error) {
                throw error;
            }
        },
        async getSubscribedPlan({ commit }, payload) {
            try {
                const response = await getSubscribedPlan(payload.id)
                if (response.status == 200) {
                    this.productPlan = response.data.data
                }

                //if trial - store expiration date
                if (this.productPlan.attributes.name == 'Pro Trial') {
                    this.productPlan.trial_ends_at = payload.attributes.trial_ends_at
                }

                commit('SET_PRODUCTPLAN', this.productPlan)

            } catch (error) {
                throw error;
            }
        },
        async getActivityEditors({ commit }, id) {
            if (this.productPlan.attributes && this.productPlan.attributes.name != 'Free') {
                try {
                    const response = await getActivityEditors(id)
                    this.list = []
                    this.liveUsers = response.data.data
                    for (let i = 0; i < this.liveUsers.length; i++) {
                        this.list.push({
                            user_id: this.liveUsers[i].attributes.user.id,
                            avatar: this.liveUsers[i].attributes.user.avatar_thumb,
                            first_name: this.liveUsers[i].attributes.user.first_name,
                            last_name: this.liveUsers[i].attributes.user.last_name,
                            feed_id: this.liveUsers[i].attributes.feed_id,
                            entity_id: this.liveUsers[i].attributes.entity_id
                        })
                    }
                    commit('SET_EDITORS', this.list)
                } catch (error) {
                    throw error;
                }
            }
        },
        async occupyEditor({ commit }, payload) {
            var itemid = payload.key1;
            var activityId = payload.key2;
            var entityType = payload.key3;
            try {

                let occupyData = {
                    data: {
                        type: "feed-edits",
                        attributes: {
                            entity_id: itemid,
                            entity_type: entityType
                        },
                        relationships: {
                            activity: {
                                data: {
                                    type: "activities",
                                    id: activityId
                                }
                            }
                        }

                    }
                };
                const setEditing = await occupyFeedEditor(occupyData);
                if (setEditing.status == 201) {
                    this.feedEditingId = setEditing.data.data.id;
                }
                commit('SET_OCCUPY', this.feedEditingId)
            } catch (error) {
                throw error;
            }
        },
        async releaseEditor({ commit }, payload) {
            var itemid = payload.key1;
            var activityId = payload.key2;
            var entityType = payload.key3;
            try {
                let releaseData = {
                    data: {
                        type: "feed-edits",
                        id: this.feedEditingId,
                        attributes: {
                            entity_id: itemid,
                            entity_type: entityType
                        },
                        relationships: {
                            activity: {
                                data: {
                                    type: "activities",
                                    id: activityId
                                }
                            }
                        }
                    }
                };
                const setNotEditing = await releaseFeedEditor(this.feedEditingId, releaseData);
                if (setNotEditing.status == 200) {
                    this.feedEditingId = setNotEditing.data.data.id;
                }
                commit('RELEASE_EDITOR', this.feedEditingId)
            } catch (error) {
                throw error;
            }

        },

        lockPlatform({ commit }, payload) {
            if (payload == 'trialExpired') {
                this.lock = true
                commit('SET_LOCK', this.lock)
            } else if (payload == 'paymentFailed') {
                this.lockPaymentFailed = true
                commit('SET_LOCK_PAYMENT_FAILED', this.lockPaymentFailed)
            } else {
                this.lockNotAcceptedTerms = true
                commit('SET_LOCK_NOT_ACCEPTED_TERMS', this.lockNotAcceptedTerms)
            }

        },
        unlockPlatform({ commit }) {
            if (this.lock == true) {
                this.lock = false
                commit('SET_LOCK', this.lock)
            }
            if (this.lockPaymentFailed == true) {
                this.lockPaymentFailed = false
                commit('SET_LOCK_PAYMENT_FAILED', this.lockPaymentFailed)
            }
            if (this.lockNotAcceptedTerms == true) {
                this.lockNotAcceptedTerms = false
                commit('SET_LOCK_NOT_ACCEPTED_TERMS', this.lockNotAcceptedTerms)
            }
        },

        setBrokenWorkflow({ commit }, payload) {
            this.workflowBroken = false
            if (payload.length > 0) {
                this.workflowBroken = true
            }
            commit('SET_WORKFLOW_BROKEN', this.workflowBroken)
        },
    },
    getters: {
        list: (state) => state.list,
        feedEditingId: (state) => state.feedEditingId,
        targetGroupTitle: (state) => state.targetGroup,
        peopleStatistics: (state) => state.peopleStatistics,
        storeOrdersStatistics: (state) => state.storeOrdersStatistics,
        lock: (state) => state.lock,
        lockPaymentFailed: (state) => state.lockPaymentFailed,
        lockNotAcceptedTerms: (state) => state.lockNotAcceptedTerms,
        productPlan: (state) => state.productPlan,
        peopleWorkflowStatistics: (state) => state.peopleStatistics,
        workflow: (state) => state.workflow,
        workflowBroken: (state) => state.workflowBroken
    },

})